"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CardContainer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return;
}